import React, { useEffect, useState } from 'react';
import "../styles/ForgotPasswordPage.css";
import { FaEye, FaEyeSlash, FaLock } from 'react-icons/fa';
import axios from 'axios';
import { GridLoader } from 'react-spinners';
import { useNavigate } from 'react-router-dom';

function ChangePassword() {

  const navigate = useNavigate();
  const [entered_otp, setEntered_otp] = useState('');
  const [message, setMessage] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState('');
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState('');
  const [otp, setOTP] = useState('');
  const [otpError, setOtpError] = useState({ otp: '' });
  const [error, setError] = useState({ password: '', confirmPassword: '' });

  const baseURL = sessionStorage.getItem('baseURL');

  useEffect(() => {
    if (sessionStorage.getItem('isLoggedIn') !== 'true') {
      navigate('/');
      return;
    }
    hideAll();
    showDiv('submitPassword');
  }, []);

  const navigateToDashboard = () => navigate('/');

  const hideAll = () => {
    document.getElementById('submitPassword').hidden = true;
    document.getElementById('loading').hidden = true;
  };

  const showDiv = (id) => {
    document.getElementById(id).hidden = false;
  };

  function showToast(message, type = 'success') {
    const toast = document.createElement('div');
    toast.innerText = message;
    Object.assign(toast.style, {
      position: 'fixed',
      top: '20px',
      right: '20px',
      background: type === 'error' ? '#d32f2f' : type === 'success' ? '#2e7d32' : '#ffa000',
      color: '#fff',
      padding: '12px 18px',
      borderRadius: '6px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
      zIndex: 9999,
      opacity: '0',
      transition: 'opacity 0.3s ease',
      fontFamily: "'Source Sans 3', sans-serif",
      fontSize: '.9rem',
    });
    document.body.appendChild(toast);
    requestAnimationFrame(() => (toast.style.opacity = '1'));
    setTimeout(() => {
      toast.style.opacity = '0';
      setTimeout(() => toast.remove(), 300);
    }, 3500);
  }

  const validateForm = () => {
    const newError = {};
    const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

    if (password === '') {
      newError.password = 'Password cannot be empty.';
    } else if (password.length < 6) {
      newError.password = 'Password must be at least 6 characters long.';
    } else if (!regex.test(password)) {
      newError.password =
        'Password must have at least 1 uppercase, 1 lowercase, 1 number, 1 special character.';
    }

    if (confirmPassword === '') {
      newError.confirmPassword = 'Confirm Password cannot be empty.';
    } else if (confirmPassword.length < 6) {
      newError.confirmPassword = 'Confirm Password must be at least 6 characters long.';
    } else if (password !== confirmPassword) {
      newError.confirmPassword = "Confirm Password doesn't match Password.";
    }

    setError(newError);
    return Object.keys(newError).length === 0;
  };

  const handleSubmitPassword = (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const email = sessionStorage.getItem('email');
    showDiv('loading');
    axios
      .get(baseURL + 'auth/updatePassword/' + email + '/' + password)
      .then(() => {
        showToast('Password Updated Successfully');
        sessionStorage.clear();
        fetch('/company.json')
          .then((res) => res.json())
          .then((data) => {
            sessionStorage.setItem('companyName', data.name);
            sessionStorage.setItem('companyLogo', data.logo);
            sessionStorage.setItem('baseURL', data.baseURL);
          })
          .catch((err) => console.error('Error fetching company data:', err));
        setTimeout(() => navigate('/'), 1000);
      })
      .catch(() => {
        showToast('Error updating password', 'error');
        hideAll();
        showDiv('submitPassword');
      });
  };

  const togglePasswordVisibility = () => setShowPassword((v) => !v);
  const toggleConfirmPasswordVisibility = () => setShowConfirmPassword((v) => !v);

  return (
    <div>
      <div className="forgot-password-container">

        <form id="submitPassword" onSubmit={handleSubmitPassword}>
          {/* ── New Password ── */}
          <label htmlFor="new-password">Password</label>
          <div className="input-group">
            <FaLock className="input-icon" aria-hidden="true" />
            <input
              id="new-password"
              type={showPassword ? 'text' : 'password'}
              value={password}
              placeholder="Enter your password"
              autoComplete="new-password"
              onChange={(e) => {
                setPassword(e.target.value);
                setError((prev) => ({ ...prev, password: '' }));
              }}
            />
            <span
              className="eye-icon"
              onClick={togglePasswordVisibility}
              role="button"
              aria-label={showPassword ? 'Hide password' : 'Show password'}
            >
              {showPassword ? <FaEye /> : <FaEyeSlash />}
            </span>
          </div>
          {error.password && (
            <div className="error-message" role="alert">{error.password}</div>
          )}

          {/* ── Confirm Password ── */}
          <label htmlFor="confirm-password">Confirm Password</label>
          <div className="input-group">
            <FaLock className="input-icon" aria-hidden="true" />
            <input
              id="confirm-password"
              type={showConfirmPassword ? 'text' : 'password'}
              value={confirmPassword}
              placeholder="Confirm your password"
              autoComplete="new-password"
              onChange={(e) => {
                setConfirmPassword(e.target.value);
                setError((prev) => ({ ...prev, confirmPassword: '' }));
              }}
            />
            <span
              className="eye-icon"
              onClick={toggleConfirmPasswordVisibility}
              role="button"
              aria-label={showConfirmPassword ? 'Hide password' : 'Show password'}
            >
              {showConfirmPassword ? <FaEye /> : <FaEyeSlash />}
            </span>
          </div>
          {error.confirmPassword && (
            <div className="error-message" role="alert">{error.confirmPassword}</div>
          )}

          <button type="submit">Submit</button>

          {message && <div className="error-message">{message}</div>}
        </form>

        {/* Loading spinner — Cadila navy */}
        <div className="loading" id="loading">
          <GridLoader color="#2C3493" loading={true} size={20} />
        </div>
      </div>
    </div>
  );
}

export default ChangePassword;